import { Reducer } from "redux";
import {
    KeyboardState,
    KeyboardActions,
    ConnectInputToKeyboardAction,
    DisconnectKeyboardAction,
    ToggleKeyboardDisableValueAction,
    PressedKeyboardButtonAction,
    SetupEnterFunctionAction,
    ChangeKeyboardMaskAction
} from "./type";
import {
    connectInputToKeyboardHandler,
    disconnectKeyboardHandler,
    toggleKeyboardDisableValueHandler,
    pressedKeyboardButtonHandler,
    setupEnterFunctionHandler,
    changeKeyboardMaskHandler
} from "./handlers";
import {
    CONNECT_KEYBOARD_TO_INPUT,
    DISCONNECT_KEYBOARD,
    TOGGLE_KEYBOARD_DISABLE_VALUE,
    SEND_KEYBOARD_VALUE,
    SETUP_ENTER_FUNCTION,
    CHANGE_KEYBOARD_MASK
} from "./constants";
import { KeyboardType } from "../../constants/keyboardTypes";

export const initialState: KeyboardState = {
    pipe: () => {},
    enterFunction: () => {},
    value: "",
    showKeyboard: false,
    isDisabled: true,
    mask: "",
    focusedElementId: "",
    keyboardType: KeyboardType.STANDARD
};

const reducer: Reducer<KeyboardState> = (state: KeyboardState = initialState, action: KeyboardActions) => {
    switch (action.type) {
        case CONNECT_KEYBOARD_TO_INPUT:
            return connectInputToKeyboardHandler(state, action as ConnectInputToKeyboardAction);

        case DISCONNECT_KEYBOARD:
            return disconnectKeyboardHandler(state, action as DisconnectKeyboardAction);

        case TOGGLE_KEYBOARD_DISABLE_VALUE:
            return toggleKeyboardDisableValueHandler(state, action as ToggleKeyboardDisableValueAction);

        case SEND_KEYBOARD_VALUE:
            return pressedKeyboardButtonHandler(state, action as PressedKeyboardButtonAction);

        case SETUP_ENTER_FUNCTION:
            return setupEnterFunctionHandler(state, action as SetupEnterFunctionAction);

        case CHANGE_KEYBOARD_MASK:
            return changeKeyboardMaskHandler(state, action as ChangeKeyboardMaskAction);

        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/Keyboard/reducer.ts